<div dir="{{languageDir}}">
<div class="production-db-content">
  <div class="content-top-box">
    <ul class="breadcrumb">
      <ul class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
          <a
            class="breadcrumb-link"
            [routerLink]="breadcrumItem.Url"
            [id]="breadcrumItem.id"
            (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)"
            >{{lang.getTransalatedValue(breadcrumItem.text)}}</a
          >
        </li>
      </ul>
    </ul>
    <div class="title-row-flex-both-end">
      <h1 class="main-title">
        {{ langObj ? langObj?.PlantMapping : ("PlantMapping" | translate) }}
      </h1>
    </div>
  </div>
  <ngx-spinner
    bdColor="rgba(0, 0, 0, 0.8)"
    template=" <img src='assets/images/spinner.gif' />"
  ></ngx-spinner>
  <form [formGroup]="plantMappingHeaderForm">
    <div class="content-top-row content-top-row-order-processing">
      <!-- GROUP -->
      <mat-form-field
        appearence="fill"
        class="top-row-first-filed-item top-row-first-filed-item-order-processing"
      >
        <mat-label>
          {{ langObj ? langObj?.Group : ("Group" | translate) }}
        </mat-label>
        <mat-select
          formControlName="group"
          placeholder="{{ langObj ? langObj?.Group : (Group' | translate) }}"
          panelClass="testClass"
          name="Status"
          (selectionChange)="getPlants()"
        >
          <mat-select-filter
            [placeholder]="'Search'"
            [displayMember]="'EG_Desc'"
            [array]="GroupList"
            (filteredReturn)="filteredGroups = $event"
          ></mat-select-filter>
          <mat-option
            *ngFor="let group of filteredGroups"
            [value]="group.EG_Id"
          >
            {{ group.EG_Desc }}
          </mat-option>
        </mat-select>
        <mat-error>
          {{
            langObj ? langObj?.GroupIsRequired : ("GroupIsRequired" | translate)
          }}
        </mat-error>
      </mat-form-field>

      <!-- plant  -->
      <mat-form-field
        appearence="fill"
        class="top-row-first-filed-item top-row-first-filed-item-order-processing w-48"
      >
        <mat-label>
          {{ langObj ? langObj?.Plant : ("Plant" | translate) }}
        </mat-label>
        <mat-select
          formControlName="plant"
          placeholder="{{ langObj ? langObj?.Plant : (Plant' | translate) }}"
          panelClass="testClass"
          name="Status"
        >
          <mat-select-filter
            [placeholder]="'Search'"
            [displayMember]="'PT_Desc'"
            [array]="PlantList"
            (filteredReturn)="filteredPlants = $event"
          ></mat-select-filter>
          <mat-option
            *ngFor="let plant of filteredPlants"
            [value]="plant.PT_Id"
          >
            {{ plant.PT_Desc }}
          </mat-option>
        </mat-select>
        <mat-error>
          {{
            langObj ? langObj?.PlantIsRequired : ("PlantIsRequired" | translate)
          }}
        </mat-error>
      </mat-form-field>

      <button
        type="button"
        [disabled]="!IsWrite"
        class="header-button clear-filter mr-1"
        pTooltip="add"
        (click)="openPopup()"
      >
        <i class="fa fa-plus" aria-hidden="true"></i>
      </button>
      <button
        [disabled]="!IsWrite"
        (click)="filterData()"
        pTooltip="Search"
        class="save"
        tooltipPosition="top"
      >
        <img src="assets/images/search.png" alt="" width="20px" height="20px" />
      </button>
    </div>
  </form>

  <mat-card-content style="margin-top: 5px">
    <ag-grid-angular
      style="width: 100%; height: 24vw"
      class="ag-theme-alpine"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      (gridReady)="onGridReady($event)"
      [gridOptions]="gridOptions"
      [pagination]="true"
      [frameworkComponents]="frameworkComponents"
      [paginationPageSize]="10"
    >
    </ag-grid-angular>
  </mat-card-content>
</div>

<ng-template #plantMappingPopup>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
      <h2>
        {{
          langObj ? langObj?.PlantMappingForm : ("PlantMappingForm" | translate)
        }}
      </h2>
      <button
        mat-mini-fab
        mat-button
        mat-dialog-close
        color="warn"
        title="close"
      >
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>

  <div class="content-top-row content-top-row-order-processing">
    <form
      [formGroup]="plantMappingForm"
      #rawMaterialDescFormDirective="ngForm"
      (ngSubmit)="saveFormData(rawMaterialDescFormDirective)"
      style="width: 100%; align-items: center; display: flex"
    >
      <mat-form-field
        class="top-row-first-filed-item top-row-first-filed-item-order-processing w-48"
        appearance="fill"
        style="width: 95%"
      >
        <mat-label>
          {{ langObj ? langObj?.Company : ("Company" | translate) }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="company"
          autocomplete="false"
        />
        <mat-error>
          {{
            langObj
              ? langObj?.CompanyIsRequired
              : ("CompanyIsRequired" | translate)
          }}
        </mat-error>
      </mat-form-field>

      <button
        [disabled]="!IsWrite"
        type="submit"
        class="save"
        tooltipPosition="top"
        matTooltip="Save"
        style="display: unset; margin-left: 20px"
      >
        <img src="assets/images/save.png" alt="" width="20px" height="20px" />
      </button>
    </form>
  </div>
</ng-template>
</div>